module.exports = __webpack_public_path__ + "static/media/fakeMap.e63b8dea.jpeg";